import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Pill, BoxSection, Typography } from "@aviary";
import { useGlobalConfig } from "@unauthenticated/shared/context";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./StoreOffersPill.styles";
interface Props {
  patientAttributes: PatientAttributes;
}

const StoreOffersPill: FC<Props> = ({ patientAttributes }) => {
  const { t } = useTranslation();
  const { isUS } = useGlobalConfig();

  const { discount } = patientAttributes;

  const getFreeShippingStyle = () => {
    if (discount) return styles.doubleSection;
    return styles.circleIcon;
  };

  const renderDiscount = () => {
    if (!discount) return null;
    return (
      <div css={styles.storeOffer}>
        <FontAwesomeIcon icon={faCheckCircle} css={styles.circleIcon} />
        <Typography type="h5">{t(l.patientRxAuth.Discount, { discount })}</Typography>
      </div>
    );
  };

  const renderFreeShipping = () => {
    if (!isUS) {
      return (
        <div css={styles.storeOffer}>
          <FontAwesomeIcon icon={faCheckCircle} css={getFreeShippingStyle()} />
          <Typography type="h5">{t(l.patientRxAuth.FreeShippingCA)}</Typography>
        </div>
      );
    }
    return (
      <div css={styles.storeOffer}>
        <FontAwesomeIcon icon={faCheckCircle} css={getFreeShippingStyle()} />
        <Typography type="h5">{t(l.patientRxAuth.FreeShippingUS)}</Typography>
      </div>
    );
  };

  return (
    <Pill isColor="primary" css={styles.pill}>
      <BoxSection isPaddingless css={styles.boxSection}>
        {renderDiscount()}
        {renderFreeShipping()}
      </BoxSection>
    </Pill>
  );
};

export { StoreOffersPill };
